import fetchInstance from "../utils/interceptor";

export class chunkFileUploadService {

    private hostIns: any;
    blobs: any = [];
    totalChunks: any;
    currChunk: any;

    constructor(hostIns : any) {
      this.blobs = [];
      this.totalChunks = null;
      this.currChunk = null;
      this.hostIns = hostIns;
    }
  
    // Simulates the getFileToken method using Promises instead of Observables
    getFileToken() {
      return new Promise((resolve, reject) => {
        // Simulate service invoke (replace with fetch or your API call)
        this.serviceInvoke('post_filetoken', 'POST', {}, {})
          .then(res => {
            resolve(res.fileToken);
          })
          .catch(err => reject(err));
      });
    }
  
    // Simulates the uploadChunkFile method using Promises
    uploadChunkFile(token : string, file : any) {
      const CHUNK_SIZE = 1024 * 1024 * 2; // Adjust chunk size (2MB)
      this.blobs = [];
      
      // Slice file into chunks
      for (let start = 0; start < file.size; start += CHUNK_SIZE) {
        const blob = file.slice(start, start + CHUNK_SIZE + 1);
        this.blobs.push(blob);
      }
  
      this.totalChunks = Math.floor(file.size / CHUNK_SIZE) + 1;
      this.currChunk = 0;
  
      return new Promise((resolve, reject) => {
        this.startChunkUpload(token, file, (value : any) => {
          resolve(value);
        });
      });
    }
  
    // Simulates the startChunkUpload method using async/await and Promises

  async startChunkUpload(token : string, file : any, callback : any) {
    const params = {
      fileToken: token
    };

    const blob = this.blobs[this.currChunk];
    const _mdat = new MultipartData();

    var reader = new FileReader();
    reader.onloadend = (evt : any) => {
      if (evt.target.readyState === FileReader.DONE) { // DONE == 2
        var dataObj: any = evt.target.result;
        dataObj = dataObj.replace(/^.*;base64,/, "");
        dataObj = dataObj.replace('data:application/octet-stream;base64,', '');
        let chunk = dataObj;

        if (this.currChunk < this.totalChunks) {
          _mdat.append('chunkNo', this.currChunk);
          _mdat.append('messageToken', token);
          _mdat.append('fileContext', 'bulkImport');
          _mdat.append('Content-Type', file?.type);
          _mdat.append('chunk', {
            data: chunk,
            fileName: file.name
          });
          let data = _mdat;
          // let headers = new HttpHeaders({
          //   'enctype': 'multipart/form-data'
          //   });
          let headers : any = {
            'Content-Type': `multipart/form-data; boundary=${_mdat.boundary}`,
          }
          this.serviceInvoke('post_uploadfaqfile_chunk', 'POST', _mdat.toString(), params, headers).then(
            (res : any) => {
              if (this.currChunk + 1 == this.totalChunks) {
                const _mdatFinal = new MultipartData();
                _mdatFinal.append('totalChunks', this.totalChunks);
                _mdatFinal.append('messageToken', token);
                _mdatFinal.append('fileExtension', file?.name.substring(file?.name.lastIndexOf('.') + 1));
                _mdatFinal.append('fileContext', "bulkImport");
                _mdatFinal.append('Content-Type', file?.type);
                _mdatFinal.append('filename', file?.name);
                let headers : any = {
                  'Content-Type': `multipart/form-data; boundary=${_mdatFinal.boundary}`,
                  'X-HTTP-Method-Override' : 'put'
                }
                this.serviceInvoke('post_uploadfaqfile_fileId', 'POST', _mdatFinal.toString(), params, headers).then(
                  (res : any) => {
                    callback(res.fileId);
                  }, (err : any) => {
                    // error message
                  }
                )
              } else {
                this.currChunk++;
                this.startChunkUpload(token, file, callback);
              }
            }, (err : any) => {
              // error message
            }
          )

        }
      } else {
        // errorListener(_scope, evt);
      }
    };
    reader.readAsDataURL(blob);
  }
    // Simulate service invocation (replace with actual API call)
    serviceInvoke(endpoint : string, method : string, data : any, params : any, headers = {}) {
      // Simulated API call using fetch
      let payload : any = {
        method,
        headers
      }
      if(data){
        payload.body = data;
      }
      return fetchInstance(endpoint, payload,  this.hostIns, params);
    }
}


export class MultipartData {
    boundary: string;
    private _fields: [string, any][] = [];
  
    constructor() {
      this.boundary = "--------MultipartData" + Math.random();
    }
  
    append(key: string, value: any) {
      this._fields.push([key, value]);
    }

    
    toString(): string {
      const boundary = this.boundary;
      let body = "";
      this._fields.forEach(field => {
        body += "--" + boundary + "\r\n";
        // File upload
        if (field[1].data) {
          const file = field[1];
          if (file.fileName) {
            body += `Content-Disposition: form-data; name="${field[0]}"; filename="${file.fileName}"\r\n`;
          } else {
            body += `Content-Disposition: form-data; name="${field[0]}"\r\n`;
          }
          if (file.type) {  // Only add Content-Type if it exists
            body += `Content-Type: ${file.type}\r\n`;
          }
          body += "Content-Transfer-Encoding: base64\r\n\r\n";
          body += `${file.data}\r\n`; // base64 data
        } else {
          body += `Content-Disposition: form-data; name="${field[0]}"\r\n\r\n`;
          body += `${field[1]}\r\n`;
        }
      });
      body += `--${boundary}--`;
      return body;
    }
}
  